/**
 * Campaign V3 product terminology helpers.
 *
 * Code still uses Chapter / Stage historically:
 *   Chapter  → product Stage (biome / content region)
 *   Stage    → product Level (individual match, e.g. 2-8)
 *
 * Persistence IDs (`chapter-1`, `chapter2-stage8`) stay unchanged in M90.
 */

import type { ChapterDefinition, StageDefinition } from '../combat/campaign/types'

/** Product name for a chapter (biome Stage). */
export function productStageName(chapter: ChapterDefinition | undefined | null): string {
  if (!chapter) return 'Stage'
  return chapter.displayName.replace(/^Chapter\s+/i, 'Stage ')
}

/** Product label for a match Level — keeps compact `2-8` ids. */
export function productLevelLabel(level: StageDefinition | undefined | null): string {
  return level?.displayLabel ?? '—'
}

/** "Stage 2 · Level 8" expanded form for detail headers. */
export function productLevelTitle(level: StageDefinition | undefined | null): string {
  if (!level) return 'Level'
  const parts = level.displayLabel.split('-')
  const stageN = parts[0] ?? '?'
  const levelN = parts[1] ?? '?'
  return `Stage ${stageN} · Level ${levelN}`
}

export const PRODUCT_COPY = {
  campaignHeading: 'Campaign',
  stageSelectAria: 'Stage select',
  levelSelectAria: 'Level select',
  backToStages: '← Stages',
  backToHome: '← Home',
  levelPrefix: 'Level',
  nextLevel: 'NEXT LEVEL',
  stageComplete: 'Stage complete',
  finishStage1Hint: 'Advanced locked · finish Stage 1 Normal+'
} as const
